export enum BUTTONTYPE {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export default BUTTONTYPE;
